<template>
  <el-dialog title="新增发布任务" :visible="visible" width="600px" :before-close="close" center>
    <el-form label-width="100px">
      <el-form-item label="定制分支">
        <el-input v-model="customBranch" />
      </el-form-item>
      <el-form-item v-if="tab === 'mini'" label="小程序分支">
        <el-input v-model="miniBranch" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="remark" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { GetKvlist } from '@/api/kv.js';
import { whereGql } from '@/graphql/util';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      customBranch: '',
      miniBranch: '',
      remark: '',
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        this.name = '';
      }
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submit() {
      if (!this.customBranch || (this.tab === 'mini' && !this.miniBranch)) {
        this.$message.error('请输入分支名');
        return;
      }
      GetKvlist({
        limit: 1,
        offset: 0,
        tableName: 'kv',
        filter: whereGql([
          {
            whereGqlType: 'is',
            key: `pipeline_default_json_${this.tab}`,
          },
        ]),
      })
        .then((res) => {
          const kv = res.kv._data[0];
          const preData = JSON.parse(kv.value);
          const data = {
            mini_branch: '',
            mini_appid: '',
            ...preData,
            custom_branch: this.customBranch,
            remark: this.remark,
          };
          if (this.tab === 'mini') {
            data.mini_branch = this.miniBranch;
          }
          console.log('meow', data);
          this.$emit('submit', data);
        })
        .catch((e) => {
          console.error(e);
          this.$message.error('获取配置失败');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/input.scss';
@import '@/styles/element/button.scss';
</style>
